import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface SettingsKey {
    is_active: unknown;
    key: any;
    settings_value: any
}

interface SettingsKeysState {
    data: SettingsKey[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const URL = import.meta.env.VITE_API_USERS_URL;

// Diet Mapping Code
export const fetchSettingsKey = createAsyncThunk<SettingsKey[], void, { rejectValue: string }>(
    'SettingsKey/fetchSettingsKey',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: SettingsKey[] }>('/get_settings_key', PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createSettingsKey = createAsyncThunk<SettingsKey, any, { rejectValue: string }>(
    'SettingsKey/createSettingsKey',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: SettingsKey }>('create_settings_key', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateSettingsKey = createAsyncThunk<SettingsKey, any, { rejectValue: string }>(
    'SettingsKey/updateSettingsKey',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: SettingsKey }>('update_settings_key', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const softDeleteSettingsKey: any = createAsyncThunk<
    number,
    number
>(
    "SettingsKey/softDeleteSettingsKey",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `delete_settings_key?id=${id}`,
                {},
                PORT, URL
            );
            return response
        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting Settings Key"
            );
        }
    }
);
export const SettingsKeySlice = createSlice({
    name: 'SettingsKey',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as SettingsKeysState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSettingsKey.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSettingsKey.fulfilled, (state, action: PayloadAction<SettingsKey[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchSettingsKey.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createSettingsKey.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createSettingsKey.fulfilled, (state, action: PayloadAction<SettingsKey>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createSettingsKey.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateSettingsKey.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateSettingsKey.fulfilled, (state, action: PayloadAction<SettingsKey>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateSettingsKey.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })

    },
});

export default SettingsKeySlice.reducer;